import React from "react";
import Cookies from "js-cookie";
import { Typography, Box } from "@mui/material";
import { BACKEND_ERROR_MSG } from "../../constants/constants";

const renderElement = (element) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        height: "100vh",
      }}
    >
      {element}
    </Box>
  );
};

const ErrorFallBack = () => {
  const defaultError = { status: "Error", statusText: "Error", data: "" };
  const [error, setError] = React.useState(defaultError);

  React.useEffect(() => {
    const errorMsg = Cookies.get(BACKEND_ERROR_MSG);

    if (errorMsg) {
      setError({ status: 512, statusText: "Error personalitzat", data: errorMsg });
    } else {
      setError({
        status: 512,
        statusText: "Error personalitzat",
        data: "Hi ha ocurregut un error inesperat, si us plau contacteu amb un administrador",
      });
    }
  }, []);

  console.error(error);

  if (error.status === 512) {
    return renderElement(
      <>
        <Typography variant="h1">{error.status}</Typography>
        <Typography variant="subtitle1" gutterBottom>
          {error.statusText}
        </Typography>
        <Typography variant="subtitle2">{error.data}</Typography>
      </>
    );
  } else if (error.status === "ERR_NETWORK") {
    return renderElement(
      <>
        <div>{"App caiguda, disculpeu les molesties."}</div>
      </>
    );
  } else {
    return renderElement(<h3>{"Hi ha ocurregut un error inesperat"}</h3>);
  }
};

export default ErrorFallBack;
